module.exports = __webpack_public_path__ + "img/totalUsers.e161f3da.svg";